import i18n from '@/lang';
import { cloneDeep } from 'lodash-es';
import { saveAs } from 'file-saver';
const ExcelJs = require('exceljs');
import { QUOTE_TYPE, QUOTE_MODE_TYPE, CARGO_TYPE, COLLECT_TYPE, BILLING_TYPE, WEIGHT_TYPE } from '@/views/finance/enums';
import { EXPRESS_TYPE, BILL_TYPE } from './utils';

// 设置表头样式
const setHeaderStyle = (worksheet) => {
  worksheet.getRow(1).font = {
    color: { argb: '000000' },
    bold: true
  };
  // // 设置表头换行
  // worksheet.getRow(1).alignment = {
  //   wrapText: true,
  //   vertical: 'middle',
  //   horizontal: 'center'
  // };
  // // 设置表头行高(可选,根据内容调整)
  // worksheet.getRow(1).height = 40;
};

/**
 * 设置列并处理换行
 * @param {Worksheet} worksheet - Excel工作表
 * @param {Array} columns - 列配置数组
 */
const setColumnsWithNewline = (worksheet, columns) => {
  worksheet.columns = columns;

  // 遍历第一行的每个单元格,处理换行
  columns.forEach((col, index) => {
    const cell = worksheet.getCell(1, index + 1);

    // 如果表头包含 \n,需要特殊处理
    if (col.header && typeof col.header === 'string' && col.header.includes('\n')) {
      console.log(`检测到换行表头 [列${index + 1}]:`, JSON.stringify(col.header));

      // 方法1: 直接使用包含 \n 的字符串（ExcelJS 会自动处理）
      cell.value = col.header;

      console.log(`单元格值已设置:`, JSON.stringify(cell.value));
    }

    // 确保单元格样式支持换行 - 这是关键！
    cell.alignment = {
      wrapText: true, // 必须启用文本换行
      vertical: 'middle', // 垂直居中
      horizontal: 'center' // 水平居中
    };

    // 设置字体样式
    cell.font = {
      bold: true,
      color: { argb: '000000' }
    };
  });

  // 根据内容调整行高 - 增加高度以容纳多行文本
  worksheet.getRow(1).height = 60;

  console.log('表头行高已设置为:', worksheet.getRow(1).height);
};

// 共用表头
const headerObj = [
  {
    header: i18n.t('basicData.TheNameOfTheQuoteProposal'), // 报价方案名称
    key: 'name',
    width: 30
  },
  {
    header: i18n.t('basicData.QuoteType'), // 报价类型
    key: 'offerType',
    width: 20
  },
  {
    header: i18n.t('receivablePayable.quotationMode'), // 报价模式
    key: 'offerMode',
    width: 20
  },
  {
    header: i18n.t('basicData.BusinessPrincipal'), // 业务主体
    key: 'providerInfoName',
    width: 30
  },
  {
    header: i18n.t('basicData.Outlets'), // 网点
    key: 'siteName',
    width: 20
  },
  {
    header: i18n.t('newOrder.TypeService'), // 服务类型
    key: 'expressType',
    width: 20
  },
  {
    header: i18n.t('placeOrder.cargoType'), // 货物类型
    key: 'cargoType',
    width: 20
  },
  {
    header: i18n.t('receivablePayable.billType'), // 账单类型
    key: 'billType',
    width: 20
  },
  {
    header: i18n.t('basicData.PartitionSchemeName'), // 分区方案
    key: 'partitionName',
    width: 30
  },
  {
    header: i18n.t('basicData.PartitionName'), // 分区
    key: 'partitionIdentifier',
    width: 20
  },
  {
    header: i18n.t('basicData.zipCode'), // 分区邮编
    key: 'postCode',
    width: 20
  },
  {
    header: i18n.t('vehicle.modelLabel'), // 车型
    key: 'vehicleType',
    width: 30
  }
];
// 特殊规则
const specialRules = [
  {
    header: i18n.t('basicData.TheNameOfTheQuoteProposal'), // 报价方案名称
    key: 'name',
    width: 30
  },
  {
    header: i18n.t('basicData.QuoteType'), // 报价类型
    key: 'offerType',
    width: 20
  },
  {
    header: i18n.t('basicData.BusinessPrincipal'), // 业务主体
    key: 'providerInfoName',
    width: 30
  },
  {
    header: i18n.t('basicData.Outlets'), // 网点
    key: 'siteName',
    width: 20
  },
  {
    header: i18n.t('basicData.PartitionSchemeName'), // 分区方案
    key: 'partitionName',
    width: 30
  },
  {
    header: i18n.t('basicData.PartitionName'), // 分区
    key: 'partitionIdentifier',
    width: 20
  },
  {
    header: i18n.t('basicData.zipCode'), // 分区邮编
    key: 'postCode',
    width: 20
  },
  {
    header: i18n.t('vehicle.modelLabel'), // 车型
    key: 'vehicleType',
    width: 30
  },
  {
    header: '*' + i18n.t('basicData.ExpenseType'), // 费用类型
    key: 'feeTypeCode',
    width: 20
  },
  {
    header: `${i18n.t('basicData.adValoremRatio')}\n(FY013、FY024、FY025、FY042)`, // 从价税比例【FY013、FY024、FY025、FY042】
    key: 'taxRate',
    width: 20
  },
  {
    header: `${i18n.t('basicData.adValoremTaxFloor')}\n(FY013、FY024、FY025、FY042)`, // 从价税最低标准
    key: 'price',
    width: 20
  },
  {
    header: `${i18n.t('basicData.GRISTaxRates')}\n(FY014、FY023)`, // GRIS税率【FY014、FY023】
    key: 'taxRate1',
    width: 20
  },
  {
    header: `${i18n.t('basicData.minimumStandard')}\n(FY014、FY023)`, // GRIS最低标准
    key: 'price1',
    width: 20
  },
  {
    header: `${i18n.t('basicData.PercentageInsurancePremium')}\n(FY005)`, // 保险费比例
    key: 'taxRate2',
    width: 20
  },
  {
    header: `${i18n.t('basicData.MinimumPremiumStandards')}\n(FY005)`, // 保险费最低标准
    key: 'price2',
    width: 20
  },
  {
    header: `${i18n.t('basicData.isAddIssn1')}\n(FY007)`, // 是否添加ISS(1-ISS税率) 【FY007】
    key: 'isISS',
    width: 30
  },
  {
    header: `${i18n.t('basicData.WhetherToAddICMS')}\n(FY008)`, // 是否添加ICMS【FY008】
    key: 'isICMS',
    width: 30
  },
  {
    header: `${i18n.t('basicData.isAddIssn')}\n(FY017)`, // 是否添加ISSn(ISS税率)【FY017】
    key: 'isISSn',
    width: 30
  },
  {
    header: `${i18n.t('basicData.CTEServiceFeePerTicket')}\n(FY020)`, // CTE-服务费/票
    key: 'price3',
    width: 20
  },
  {
    header: `${i18n.t('basicData.issuanceFeePerTicket')}\n(FY016)`, // 发行费（票）
    key: 'price4',
    width: 20
  },
  {
    header: `${i18n.t('basicData.operationFeePerTicket')}\n(FY002)`, // 操作费（票）
    key: 'price5',
    width: 20
  },
  {
    header: `${i18n.t('basicData.OverweightHandlingFeeForOverweight')}(KG)\n(FY011、FY021、FY038)`, // 超重处理费超重(KG)【FY021、FY011、FY038】
    key: 'weight',
    width: 20
  },
  {
    header: `${i18n.t('basicData.OverweightHandlingFee1')}(BRL)\n(FY011、FY021、FY038)`, // 超重处理费(BRL)
    key: 'price6',
    width: 20
  },
  {
    header: `${i18n.t('basicData.PalletHandlingChargesAreOverweight')}(KG)\n(FY009)`, // 托盘操作处理费超重(KG)
    key: 'weight1',
    width: 30
  },
  {
    header: `${i18n.t('basicData.PalletHandlingHandlingFee')}(BRL)\n(FY009)`, // 托盘操作处理费(BRL)
    key: 'price7',
    width: 30
  },
  {
    header: `${i18n.t('basicData.riskManagementTaxRate')}\n(FY006)`, // 风险管理费税率
    key: 'taxRate3',
    width: 20
  },
  {
    header: `${i18n.t('basicData.roadTollKG')}\n(FY015、FY022、FY039)`, // 过路费/KG 【FY022、FY015、FY039】
    key: 'weight2',
    width: 30
  },
  {
    header: `${i18n.t('basicData.roadTollBRL')}\n(FY015、FY022、FY039)`, // 过路费（BRL）
    key: 'price8',
    width: 30
  },
  {
    header: `${i18n.t('basicData.InsuranceType')}\n(FY028)`, // 保险类型 【FY028】
    key: 'ruleType',
    width: 30
  },
  {
    header: `${i18n.t('orderCenterCont.proportions')}\n(FY028)`, // 保险类型比例
    key: 'taxRate4',
    width: 30
  },
  {
    header: `${i18n.t('basicData.LoadingFee')}\n(FY029)`, // 装车费 【FY029】
    key: 'price9',
    width: 30
  },
  {
    header: `${i18n.t('basicData.UnloadingFee')}\n(FY030)`, // 卸车费 【FY030】
    key: 'price10',
    width: 30
  },
  {
    header: `${i18n.t('basicData.CRISAndAdValoremTaxRate')}\n(FY040)`, // CRIS & 从价税税率 【FY040】
    key: 'taxRate5',
    width: 30
  },
  {
    header: `${i18n.t('basicData.CRISAndAdValoremTaxMinimumStandard')}\n(FY040)`, // CRIS & 从价税最低标准 【FY040】
    key: 'price11',
    width: 30
  },
  {
    header: `${i18n.t('basicData.ShippingTaxRate')}\n(FY041)`, // 船运税税率 【FY041】
    key: 'taxRate7',
    width: 30
  },
  {
    header: `${i18n.t('basicData.ShippingTaxMinimumStandard')}\n(FY041)`, // 船运税最低标准 【FY041】
    key: 'price12',
    width: 30
  },
  {
    header: `${i18n.t('receivablePayable.TaxRate')}\n(FY043、FY044、FY045、FY046)`, // 税率 【FY043、FY044、FY045、FY046】
    key: 'taxRate6',
    width: 30
  }
];
// 快递/派件-[区间价]/揽收-普通揽收
const expressDelivery = [
  {
    header: '*' + i18n.t('basicData.ExpenseType'), // 费用类型
    key: 'feeTypeCode',
    width: 20
  },
  {
    header: '*' + i18n.t('basicData.chargeType'), // 计费类型
    key: 'billingType',
    width: 20
  },
  {
    header: '*' + i18n.t('basicData.Begin'), // 开始
    key: 'startWeight',
    width: 30
  },
  {
    header: '*' + i18n.t('basicData.end'), // 结束
    key: 'endWeight',
    width: 30
  },
  {
    header: '*' + i18n.t('basicData.Price'), // 价格
    key: 'price',
    width: 30
  },
  {
    header: i18n.t('basicData.ExceedingThePrice'), // 超出价格
    key: 'overWeightExtraPrice',
    width: 30
  }
];
// 普通揽收
const normalCollection = [
  {
    header: '*' + i18n.t('collectionCenter.lanshouTypee'), // 揽收方式
    key: 'collectType',
    width: 20
  }
];
// 备货揽收
const stowageCollection = [
  {
    header: '*' + i18n.t('basicData.ExpenseType'), // 费用类型
    key: 'feeTypeCode',
    width: 20
  },
  {
    header: '*' + i18n.t('basicData.BoxCountStartsNotIncluded'), // 箱数开始(不包含)
    key: 'startCases',
    width: 20
  },
  {
    header: '*' + i18n.t('basicData.EndOfCaseCountIncluded'), // 箱数结束(包含)
    key: 'endCases',
    width: 20
  },
  {
    header: '*' + i18n.t('basicData.Price'), // 价格
    key: 'price',
    width: 20
  },
  {
    header: i18n.t('basicData.ExceedingThePrice'), // 超出价格
    key: 'overExtraPrice',
    width: 20
  }
];
// 快递/派件-[续重]
const dispatch = [
  {
    header: '*' + i18n.t('basicData.ExpenseType'), // 费用类型
    key: 'feeTypeCode',
    width: 20
  },
  {
    header: '*' + i18n.t('receivablePayable.weightType'), // 重量类型
    key: 'weightType',
    width: 20
  },
  {
    header: '*' + i18n.t('receivablePayable.weightStart'), // 重量开始（KG）(不包含)
    key: 'startWeight',
    width: 30
  },
  {
    header: '*' + i18n.t('receivablePayable.continuedWeightEnd'), // 续重结束(包含)
    key: 'endWeight',
    width: 30
  },
  {
    header: '*' + i18n.t('basicData.Price'), // 价格
    key: 'price',
    width: 20
  }
];

/**
 * columns
 * @param form 报价详情
 */
const getColumns = (form) => {
  const sheet_columns = [];
  const { businessType, offerMode, collectionCategory } = form;
  // 快递、派件【区间价】
  if ([0, 2].includes(businessType) && offerMode === 0) {
    sheet_columns.push(...expressDelivery);
  }
  // 快递、派件【续重】
  if ([0, 2].includes(businessType) && offerMode === 1) {
    sheet_columns.push(...dispatch);
  }
  // 揽收【普通揽收】
  if (businessType === 1 && collectionCategory === 0) {
    const cloneExpressDelivery = cloneDeep(expressDelivery);
    cloneExpressDelivery.splice(2, 0, ...normalCollection);
    sheet_columns.push(...cloneExpressDelivery);
  }
  // 揽收【备货揽收】
  if (businessType === 1 && collectionCategory === 1) {
    sheet_columns.push(...stowageCollection);
  }
  // 整车
  if (businessType === 8) {
    sheet_columns.push(...expressDelivery);
  }
  return sheet_columns;
};

/**
 * 数据填充
 * @param type 1 普通规则 2 其他规则
 * @param form 报价详情
 * @param data 价格详情
 * @param expenseTypeList 费用类型
 * @param specialFeeList 特殊费用
 * @param insuranceTypeList 保险类型
 * @param modelList 车型
 */
const fillData = (type, form, data = [], expenseTypeList = [], specialFeeList = [], insuranceTypeList = [], modelList = []) => {
  const { name, offerMode, offerType, providerInfoName, sitaName, expressType, cargoType, billType, partitionName } = form;
  let Sheet_data = [];
  // 查找费用类型
  const expenseTypeMap = expenseTypeList && Array.isArray(expenseTypeList)
    ? new Map(expenseTypeList.map(type => [type.code, type.name]))
    : new Map();

  const specialFeeMap = specialFeeList && Array.isArray(specialFeeList)
    ? new Map(specialFeeList.map(type => [type.code, type.name]))
    : new Map();

  // 添加数据
  if (type === 1) {
    Sheet_data = data.map(item => {
      const { feeTypeCode, billingType, collectType, weightType, vehicleType } = item;

      return {
        ...item,
        feeTypeCode: (expenseTypeMap.get(feeTypeCode)) || '',
        weightType: (WEIGHT_TYPE[weightType] && WEIGHT_TYPE[weightType].label) || '',
        collectType: (COLLECT_TYPE[collectType] && COLLECT_TYPE[collectType].label) || '',
        billingType: (BILLING_TYPE[billingType] && BILLING_TYPE[billingType].label) || '',
        offerType: (QUOTE_TYPE[offerType] && QUOTE_TYPE[offerType].label) || '',
        offerMode: (QUOTE_MODE_TYPE[offerMode] && QUOTE_MODE_TYPE[offerMode].label) || '',
        expressType: (EXPRESS_TYPE[expressType] && EXPRESS_TYPE[expressType].name) || '',
        cargoType: (CARGO_TYPE[cargoType] && CARGO_TYPE[cargoType].label) || '',
        billType: (BILL_TYPE[billType] && BILL_TYPE[billType].name) || '',
        vehicleType: modelList.find(model => model.dictValue === vehicleType)?.dictLabel || '',
        name, providerInfoName, sitaName, partitionName
      };
    });
  } else {
    console.log('特殊规则', data);
    const feeTypeMap = {
      FY002: { price: 'price5' }, // 操作费
      FY005: { taxRate: 'taxRate2', price: 'price2' }, // 保险费
      FY006: { taxRate: 'taxRate3' }, // 风险管理费
      FY009: { weight: 'weight1', price: 'price7' }, // 托盘处理费
      FY011: { weight: 'weight', price: 'price6' }, // 超重处理费
      FY013: { taxRate: 'taxRate', price: 'price' }, // 从价税
      FY014: { taxRate: 'taxRate1', price: 'price1' }, // GRIS
      FY015: { weight: 'weight2', price: 'price8' }, // 过路费
      FY016: { price: 'price4' }, // 发行费
      FY020: { price: 'price3' }, // CT-e
      FY021: { weight: 'weight', price: 'price6' }, // 超重（kg）
      FY022: { weight: 'weight2', price: 'price8' }, // 仓库异常费
      FY023: { taxRate: 'taxRate1', price: 'price1' }, // GRIS2
      FY024: { taxRate: 'taxRate', price: 'price' }, // 从价税2
      FY025: { taxRate: 'taxRate', price: 'price' }, // 内河运输费
      FY028: { ruleType: 'ruleType', taxRate: 'taxRate4' }, // 运输保险费+比例
      FY029: { price: 'price9' }, // 装车费
      FY030: { price: 'price10' }, // 卸车费
      FY038: { weight: 'weight', price: 'price6' }, // 风险区域费
      FY039: { weight: 'weight2', price: 'price8' }, // 路桥费
      FY040: { taxRate: 'taxRate5', price: 'price11' }, // GRIS & 从价税
      FY041: { taxRate: 'taxRate7', price: 'price12' }, // 船运费
      FY042: { taxRate: 'taxRate', price: 'price' }, // 河运物流税
      FY043: { taxRate: 'taxRate6' }, // CRIS3
      FY044: { taxRate: 'taxRate6' }, // CRIS4
      FY045: { taxRate: 'taxRate6' }, // 保险费2
      FY046: { taxRate: 'taxRate6' } // 保险费3
    };
    Sheet_data = data.map(item => {
      const { feeTypeCode, ruleType, vehicleType, partitionIdentifier } = item;
      const data = { name, providerInfoName, sitaName, partitionName, partitionIdentifier };
      const mapping = feeTypeMap[feeTypeCode];
      if (mapping) {
        Object.keys(mapping).forEach(key => {
          data[mapping[key]] = item[key];
        });
      } else {
        console.warn(`未知的 feeTypeCode: ${feeTypeCode}`);
      }

      // 是否添加ICMS/ISS FY007、FY008、FY017
      const feeConfig = {
        FY007: { key: 'isISS', labelYes: i18n.t('GlobalSetObj.yes'), labelNo: i18n.t('GlobalSetObj.No') },
        FY008: { key: 'isICMS', labelYes: i18n.t('GlobalSetObj.yes'), labelNo: i18n.t('GlobalSetObj.No') },
        FY017: { key: 'isISSn', labelYes: i18n.t('GlobalSetObj.yes'), labelNo: i18n.t('GlobalSetObj.No') }
      };

      Object.keys(feeConfig).forEach(code => {
        const config = feeConfig[code];
        if (feeTypeCode === code) {
          data[config.key] = `${config.labelYes}->1`;
        } else {
          data[config.key] = `${config.labelNo}->0`;
        }
      });

      data.feeTypeCode = (specialFeeMap.get(feeTypeCode)) || '';
      data.offerType = (QUOTE_TYPE[offerType] && QUOTE_TYPE[offerType].label) || '';
      data.offerMode = (QUOTE_MODE_TYPE[offerMode] && QUOTE_MODE_TYPE[offerMode].label) || '';
      data.expressType = (EXPRESS_TYPE[expressType] && EXPRESS_TYPE[expressType].name) || '';
      data.cargoType = (CARGO_TYPE[cargoType] && CARGO_TYPE[cargoType].label) || '';
      data.billType = (BILL_TYPE[billType] && BILL_TYPE[billType].name) || '';
      data.ruleType = insuranceTypeList.find(item => item.dictValue === ruleType)?.dictLabel || '';
      data.vehicleType = modelList.find(model => model.dictValue === vehicleType)?.dictLabel || '';

      return data;
    });
  }
  return Sheet_data;
};

/**
 * 日志下载报价
 * @param form 报价详情
 * @param data 价格详情
 * @param otherData 其他规则
 * @param expenseTypeList 费用类型
 * @param specialFeeList 特殊费用
 * @param insuranceTypeList 保险类型
 * @param modelList 车型
 */
const createTemplate = (form, data, otherData, expenseTypeList, specialFeeList, insuranceTypeList, modelList) => {
  const wb = new ExcelJs.Workbook();
  const Sheet1 = wb.addWorksheet('基础报价'); // 普通规则
  const Sheet2 = wb.addWorksheet('其他报价'); // 特殊规则
  setHeaderStyle(Sheet1);
  setHeaderStyle(Sheet2);

  const sheet_data = getColumns(form);
  const columns = [...headerObj, ...sheet_data];
  console.log(columns, '----------------------------基础报价列头');
  // 使用支持换行的列设置方法
  setColumnsWithNewline(Sheet1, columns);
  setColumnsWithNewline(Sheet2, specialRules);

  const Sheet1_data = fillData(1, form, data, expenseTypeList, specialFeeList, insuranceTypeList, modelList);
  console.log(Sheet1_data, '----------------------------基础报价');
  Sheet1.addRows(Sheet1_data);

  const Sheet2_data = fillData(2, form, otherData, expenseTypeList, specialFeeList, insuranceTypeList, modelList);
  console.log(Sheet2_data, '----------------------------特殊报价');
  Sheet2.addRows(Sheet2_data);
  return wb;
};

/**
 * 下载文件
 * @param form 报价详情
 * @param data 价格详情
 * @param otherData 其他规则
 * @param expenseTypeList 费用类型
 * @param specialFeeList 特殊费用
 * @param insuranceTypeList 保险类型
 * @param modelList 车型
 */
export const downloadFile = async(form, data, otherData, expenseTypeList, specialFeeList, insuranceTypeList, modelList) => {
  const wb = await createTemplate(form, data, otherData, expenseTypeList, specialFeeList, insuranceTypeList, modelList);
  const { name } = form;
  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/octet-stream'
  });

  saveAs(blob, `${name}-${i18n.t('basicData.QuoteDetails')}.xlsx`);
};

/**
 * 下载模板及报价
 * @param type 1: 下载模板 2: 下载报价 3: 下载其他报价
 * @param importType 1 普通规则 2 特殊规则
 * @param formData 报价详情
 * @param subregionList 分区列表
 * @param modelList 车型列表
 * @param expenseTypeList 普通费用
 * @param specialFeeList 特殊费用
 * @param insuranceTypeList 保险类型
 * @param collectFeesArr 报价明细
 * @returns  workbook
 */
const partitionColumn = {
  header: '*' + i18n.t('basicData.PartitionName') + '/' + i18n.t('vehicle.modelLabel'), // 分区
  key: 'partitionIdentifier',
  width: 30
};
const addTemplate = (
  type,
  importType,
  formData,
  subregionList,
  modelList,
  expenseTypeList,
  specialFeeList,
  insuranceTypeList,
  collectFeesArr
) => {
  const { businessType, offerMode, collectionCategory } = formData;
  const wb = new ExcelJs.Workbook();
  const Sheet1 = wb.addWorksheet('Sheet1');
  setHeaderStyle(Sheet1);
  const feeSource = importType === 1 ? expenseTypeList : specialFeeList;
  console.log(feeSource, 'feeSource');
  const columns = [];

  // columns添加
  if (importType === 1) {
    const sheet_columns = getColumns(formData);
    columns.push(...sheet_columns);
  } else {
    const data = specialRules.slice(8);
    columns.push(...data);
  }
  console.log(columns, 'columns');
  // 下载模板
  if (type === 1) {
    const Sheet2 = wb.addWorksheet('Sheet2');
    const Sheet3 = wb.addWorksheet('Sheet3');
    const Sheet4 = wb.addWorksheet('Sheet4');
    const Sheet5 = wb.addWorksheet('Sheet5');
    const Sheet6 = wb.addWorksheet('Sheet6');
    // 模板columns
    columns.unshift(partitionColumn);
    // 使用支持换行的列设置方法
    setColumnsWithNewline(Sheet1, columns);

    const Sheet2_data = [];
    const Sheet3_data = [];
    let Sheet4_data = [];
    let Sheet5_data = [];
    let Sheet6_data = [];
    // Sheet2: 分区/车型信息
    // 使用支持换行的列设置方法
    setColumnsWithNewline(Sheet2, [
      partitionColumn,
      {
        header: i18n.t('basicData.PartitionName') + '/' + i18n.t('vehicle.modelLabel') + '(ID)', // 分区ID
        key: 'partitionAffiliateId',
        width: 20
      }
    ]);
    const columnsData = businessType === 8 ? modelList : subregionList;
    if (Array.isArray(columnsData)) {
      for (const item of columnsData) {
        if (businessType === 8) {
          Sheet2_data.push({
            partitionAffiliateId: item.dictValue,
            partitionIdentifier: `${item.dictLabel}->${item.dictValue}`
          });
        } else {
          Sheet2_data.push({
            partitionAffiliateId: item.id,
            partitionIdentifier: `${item.partitionIdentifier}->${item.id}`
          });
        }
      }
    }
    Sheet2.addRows(Sheet2_data);
    // Sheet3: 费用类型
    // 使用支持换行的列设置方法
    setColumnsWithNewline(Sheet3, [
      {
        header: i18n.t('basicData.ExpenseType') + '(' + i18n.t('ChannelManage.name') + ')', // 费用类型
        key: 'feeTypeName',
        width: 30
      },
      {
        header: i18n.t('basicData.ExpenseType') + '(code)', // 费用类型
        key: 'feeTypeCode',
        width: 20
      }
    ]);

    for (const item of feeSource) {
      Sheet3_data.push({
        feeTypeCode: item.code,
        feeTypeName: `${item.displayName}->${item.code}`
      });
    }
    Sheet3.addRows(Sheet3_data);
    if (importType === 1) {
      // Sheet4: 计费类型
      // 使用支持换行的列设置方法
      setColumnsWithNewline(Sheet4, [
        {
          header: i18n.t('basicData.chargeType') + '(' + i18n.t('ChannelManage.name') + ')', // 计费类型
          key: 'chargeType',
          width: 20
        },
        {
          header: i18n.t('basicData.chargeType') + '(id)', // 计费类型
          key: 'billingType',
          width: 20
        }
      ]);
      if (businessType === 8) {
        Sheet4_data = [
          {
            chargeType: `${i18n.t('collectionCenter.distance')}->4`, // 距离
            billingType: 4
          }
        ];
      } else {
        Sheet4_data = [
          {
            chargeType: `${i18n.t('newOperationCenter.Weight')}->1`, // 重量
            billingType: 1
          },
          {
            chargeType: `${i18n.t('collectionCenter.ballot')}->2`, // 票
            billingType: 2
          }
        ];
      }
      Sheet4.addRows(Sheet4_data);
      // Sheet5: 揽收方式
      // 使用支持换行的列设置方法
      setColumnsWithNewline(Sheet5, normalCollection);
      Sheet5_data = [
        { collectType: `${i18n.t('collectionCenter.dropOff')}->1` },
        { collectType: `${i18n.t('collectionCenter.doorPickUp')}->2` }
      ];
      Sheet5.addRows(Sheet5_data);
      // Sheet6: 重量类型
      // 使用支持换行的列设置方法
      setColumnsWithNewline(Sheet6, [
        {
          header: i18n.t('receivablePayable.weightType') + '(' + i18n.t('ChannelManage.name') + ')',
          key: 'chargeType',
          width: 20
        },
        {
          header: i18n.t('receivablePayable.weightType') + '(id)',
          key: 'weightType',
          width: 20
        }
      ]);
      Sheet6_data = [
        {
          chargeType: i18n.t('receivablePayable.initialWeight') + '->' + 0,
          weightType: 0
        }, // 首重
        {
          chargeType: i18n.t('receivablePayable.renewWeight') + '->' + 1,
          weightType: 1
        } // 续重
      ];
      Sheet6.addRows(Sheet6_data);
    } else {
      // 特殊规则模式下的 Sheet4 内容
      // 使用支持换行的列设置方法
      setColumnsWithNewline(Sheet4, [
        {
          header: i18n.t('GlobalSetObj.status'),
          key: 'isAdd',
          width: 20
        }
      ]);
      Sheet4_data = [
        { isAdd: `${i18n.t('GlobalSetObj.yes')}->1` },
        { isAdd: `${i18n.t('GlobalSetObj.No')}->0` }
      ];
      Sheet4.addRows(Sheet4_data);
      Sheet5.columns = [
        {
          header: i18n.t('basicData.InsuranceType'), // 保险类型
          key: 'ruleType',
          width: 30
        }
      ];
      // 使用支持换行的列设置方法
      setColumnsWithNewline(Sheet5, [
        {
          header: i18n.t('basicData.InsuranceType'), // 保险类型
          key: 'ruleType',
          width: 30
        }
      ]);
      for (const item of insuranceTypeList) {
        Sheet5_data.push({
          ruleType: `${item.dictLabel}->${item.dictValue}`
        });
      }
      Sheet5.addRows(Sheet5_data);
    }

    const maxRowCount = Math.max(Sheet1.rowCount, 10000);
    for (let idx = 2; idx <= maxRowCount; idx++) {
      Sheet1.getCell(`A${idx}`).dataValidation = {
        type: 'list',
        formulae: [`=Sheet2!$A$2:$A$${Sheet2_data.length + 1}`]
      };
      Sheet1.getCell(`B${idx}`).dataValidation = {
        type: 'list',
        formulae: [`=Sheet3!$A$2:$A$${Sheet3_data.length + 1}`]
      };
      // 普通规则
      if (importType === 1) {
        if ([0, 2].includes(businessType) && offerMode === 0 || businessType === 8) {
          // 快递、派件【区间价】
          Sheet1.getCell(`C${idx}`).dataValidation = {
            type: 'list',
            formulae: [`=Sheet4!$A$2:$A$${Sheet4_data.length + 1}`]
          };
        }
        if (businessType === 1 && collectionCategory === 0) {
          // 揽收【普通揽收】
          Sheet1.getCell(`C${idx}`).dataValidation = {
            type: 'list',
            formulae: [`=Sheet4!$A$2:$A$${Sheet4_data.length + 1}`]
          };
          Sheet1.getCell(`D${idx}`).dataValidation = {
            type: 'list',
            formulae: [`=Sheet5!$A$2:$A$${Sheet5_data.length + 1}`]
          };
        }
        if ([0, 2].includes(businessType) && offerMode === 1) {
          // 快递、派件【续重】
          Sheet1.getCell(`C${idx}`).dataValidation = {
            type: 'list',
            formulae: [`=Sheet6!$A$2:$A$${Sheet6_data.length + 1}`]
          };
        }
      } else {
        // 特殊规则
        ['I', 'J', 'K'].forEach((col, index) => {
          Sheet1.getCell(`${col}${idx}`).dataValidation = {
            type: 'list',
            formulae: [`=Sheet4!$A$2:$A$${Sheet4_data.length + 1}`]
          };
        });
        ['V'].forEach((col, index) => {
          Sheet1.getCell(`${col}${idx}`).dataValidation = {
            type: 'list',
            formulae: [`=Sheet5!$A$2:$A$${Sheet5_data.length + 1}`]
          };
        });
      }
    }
  } else {
    // 下载报价
    columns.unshift(...headerObj);
    // 使用支持换行的列设置方法
    setColumnsWithNewline(Sheet1, columns);
    console.log('下载报价-805', formData);
    const Sheet1_data = fillData(importType, formData, collectFeesArr, expenseTypeList, specialFeeList, insuranceTypeList, modelList);
    console.log(Sheet1_data, 'Sheet1_data');
    Sheet1.addRows(Sheet1_data);
  }
  return wb;
};

/**
 * 下载模板及报价
 * type 1 下载模板 2 下载报价 3 下载其他报价
 * importType 1 普通规则 2 其他规则
 * formData 详情
 * subregionList 分区
 * modelList 车型
 * specialFeeList 特殊费用
 * insuranceTypeList 保险类型
 * collectFeesArr 报价明细
 */
export const downloadTemplate = async(
  type,
  importType,
  formData,
  subregionList = [],
  modelList = [],
  expenseTypeList = [],
  specialFeeList = [],
  insuranceTypeList = [],
  collectFeesArr = []
) => {
  const wb = await addTemplate(type, importType, formData, subregionList, modelList, expenseTypeList, specialFeeList, insuranceTypeList, collectFeesArr);
  const timestamp = new Date().getTime();
  let saveName = '';
  // 参数校验
  const fileName = formData?.name || '';

  if (importType === 1) {
    saveName = type === 1
      ? i18n.t('basicData.ImportQuotationTemplatesInBulk') + '.xlsx'
      : `${fileName}-${timestamp}.xlsx`;
  } else {
    saveName = type === 1
      ? i18n.t('basicData.ImportOtherQuoteTemplatesBulk') + '.xlsx'
      : `${i18n.t('basicData.otherRules')}-${fileName}-${timestamp}.xlsx`;
  }
  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/octet-stream'
  });
  saveAs(blob, saveName);
};

/**
 * 导入报价
 * type 1 普通报价 2 其他报价
 * form 报价详情
 * data excel数据
 */
export const importQuotation = (type, form, data) => {
  console.log(type, form, data, 'importQuotation');
  try {
    const excel_data = data[0].results;
    const excel_header = data[0].header;
    const columns = [];
    if (type === 1) {
      const sheet_columns = getColumns(form);
      columns.push(...sheet_columns);
    } else {
      const data = specialRules.slice(8);
      columns.push(...data);
    }
    columns.unshift(partitionColumn);
    console.log(columns, 'columns', excel_header);
    // 校验上传模板
    if (columns.length !== excel_header.length) {
      throw new Error(i18n.t('basicData.templateError'));
    }
    // 需要特殊处理字段
    const Arr = [
      '*' + i18n.t('basicData.PartitionName') + '/' + i18n.t('vehicle.modelLabel'), // 分区
      '*' + i18n.t('basicData.ExpenseType'), // 费用类型
      '*' + i18n.t('basicData.chargeType'), // 计费类型
      '*' + i18n.t('collectionCenter.lanshouTypee'), // 揽收方式
      '*' + i18n.t('receivablePayable.weightType'), // 重量类型
      i18n.t('basicData.InsuranceType'), // 保险类型
      i18n.t('basicData.isAddIssn1'), // 是否添加ISS(1-ISS税率) 【FY007】
      i18n.t('basicData.WhetherToAddICMS'), // 是否添加ICMS【FY008】
      i18n.t('basicData.isAddIssn') // 是否添加ISSn(ISS) 【FY017】
    ];
    // 初始化
    const allData = [];
    excel_data.forEach((item, index) => {
      const data = {};
      excel_header.map(list => {
        data[list] = (item[list] !== '' && item[list] !== null && item[list] !== undefined) ? item[list] : '';
      });
      allData.push(data);
    });
    // 数据解析
    const sheet_data = [];
    console.log(allData, 'allData');
    allData.forEach(item => {
      const data = {};
      Object.keys(item).forEach((key, index) => {
        if (Arr.includes(key)) {
          console.log('需解析key', key, columns[index].key, item[key]);
          try {
            data[columns[index].key] = item[key] ? item[key].split('->')[1] : '';
          } catch (error) {
            console.log(error, 'error');
          }
        } else {
          // console.log('无需解析key', key, columns[index].key, item[key]);
          data[columns[index].key] = item[key];
        }
      });
      sheet_data.push(data);
    });
    sheet_data.forEach(item => {
      item.partitionAffiliateId = item.partitionIdentifier || '';
      item.billingType = item.billingType ? parseInt(item.billingType) : '';
      item.weightType = item.weightType ? parseInt(item.weightType) : '';
      item.collectType = item.collectType ? parseInt(item.collectType) : '';
    });
    console.log(sheet_data, 'sheet_data');
    return {
      data: sheet_data
    };
  } catch (error) {
    console.log(error, 'error');
    return {
      data: []
    };
  }
};

